import { h, Component, Fragment } from 'preact';
import style from './index.less'

class Input extends Component {
    constructor(props){
        super(props)
        this.state = {
            value: props.value,
            showList: false
        }
        this.onChange = this.onChange.bind(this)
        this.handleFormat = this.handleFormat.bind(this)
        this.onFocus = this.onFocus.bind(this)
    }
    onChange(e){
        this.setState({
            value: e.target.value
        }, ()=>{
            this.props.onChange && this.props.onChange(e)
        })
    }

    onFocus(){
        this.setState({
            showList: true
        })
    }

    handleFormat(e){

        if(this.state.showList){
            this.setState({
                showList: false
            })
        }

        let value = this.state.value

        if((this.props.masks || []).includes('phone') && !value.match(/\D/g)){
            value = value.replace(/\D/g, "")
            value = value.split("")
            
            
            if(value.length > 3){
                value.splice(3, 0, '-')
            }
            
            if(value.length > 7){
                value.splice(7, 0, '-')
            }
            
            if(value.length < 13){
                this.setState({
                    value: value.join('')
                }, ()=>{
                    this.props.onChange({
                        preventDefalut: ()=>{},
                        target: this.inputElement
                    })
                })
            }
        }

        this.props.onBlur && this.props.onBlur(e)
        this.setState({
            lastChangeAt: (new Date()).getTime()
        })
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.value !== this.props.value){
            this.setState({
                value: nextProps.value
            })
        }
    }
    render(){
        const classes = [style.input];
        this.props.dark && classes.push(style.dark)
        this.props.class && classes.push(this.props.class)
        this.props.required && this.props.interacted && classes.push(style.required)
        const opts = {}
        
        if(this.props.step) opts.step = this.props.step
        if(this.props.min) opts.min = this.props.min
                
        return (
            <div>
                <input 
                    id={this.props.id}
                    required={this.props.required}
                    pattern={this.props.pattern}
                    ref={(element)=> this.inputElement = element}
                    class={classes.join(' ')}
                    name={this.props.name}
                    onChange={this.onChange}
                    onInput={this.onChange}
                    onLoad={this.onChange}
                    onBlur={this.handleFormat}
                    onFocus={this.onFocus}
                    {...opts}
                    type={this.state.type || this.props.type || 'text'} 
                    value={this.state.value}
                    placeholder={this.props.placeholder || ''} 
                    autoComplete={this.props.autoComplete || ''}
                    key={this.props.key}
                />
            </div>
        )
    }
}

export default Input


// WEBPACK FOOTER //
// ./components/elements/Input/index.js